/** Sắp xếp timeline chat: created_at ASC, tie-break id ASC. */
export function compareChatMessages(a, b) {
    const ta = a?.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b?.created_at ? new Date(b.created_at).getTime() : 0;
    if (ta !== tb) {
        return ta - tb;
    }
    return Number(a?.id ?? 0) - Number(b?.id ?? 0);
}
export function sortChatMessages(messages) {
    return messages.slice().sort(compareChatMessages);
}
export function dedupeChatMessagesById(messages) {
    const seen = new Set();
    const out = [];
    for (const m of messages) {
        if (!m) {
            continue;
        }
        const id = m.id;
        if (id == null) {
            out.push(m);
            continue;
        }
        const key = String(id);
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        out.push(m);
    }
    return out;
}
/** Gộp batch cũ hơn (ASC) vào đầu list hiện tại — loại trùng id, sort lại. */
export function mergeOlderChatMessages(olderBatch, currentList) {
    return sortChatMessages(dedupeChatMessagesById([...olderBatch, ...currentList]));
}
export function appendChatMessageIfNew(list, message) {
    if (!message) {
        return list;
    }
    const id = message.id;
    if (id != null && list.some((m) => String(m.id) === String(id))) {
        return list;
    }
    return sortChatMessages([...list, message]);
}
/** Gộp hai list ASC (cache + soft-sync API) — dedupe id, sort lại. */
export function mergeChatMessageLists(existing, incoming) {
    return sortChatMessages(dedupeChatMessagesById([...(existing || []), ...(incoming || [])]));
}
export { CHAT_MESSAGE_LIST_MAX, trimNewestMessages, trimAfterPrependOlder, } from "./chatMemory";
